import React from "react";

export const customFontFamily = {
  bold: "font-bold",
  normal: "font-normal",
  semibold: "font-semibold",
  boldFont: "font-bold",
  normalFont: "",
  italic: "italic",
};

export const config = {
  fontSizeXs: "text-xs",
  fontSizeSm: "text-[11px]",
  fontSizeBase: "text-[12px]",
  fontSizeLg: "text-[12.5px]",
  fontSizeTitle: "text-sm",
  jkRefPrefix: "DYC/HR-JK/",
};

const FulltimeJoiningPDF = ({
  candidateName,
  candidateAddress,
  candidateMobile,
  candidateEmail,
  jkRefCode,
  offerDateFormatted,
}) => {
  return (
    <div className={`bg-white text-gray-900 ${config.fontSizeLg} space-y-4`}>
      <div className={`flex justify-between items-center ${customFontFamily.semibold} text-gray-800 ${config.fontSizeXs}`}>
        <div>{jkRefCode}</div>
        <div>Date: {offerDateFormatted}</div>
      </div>

      <div className="space-y-0.5 text-gray-900">
        <div>To,</div>
        <div className={`${customFontFamily.bold} ${config.fontSizeTitle}`}>{candidateName},</div>
        {candidateAddress && <div>Address: {candidateAddress}</div>}
        {candidateMobile && <div>Mobile: {candidateMobile}</div>}
        {candidateEmail && <div>Email: {candidateEmail}</div>}
      </div>

      <div className={`${customFontFamily.bold} text-gray-900 ${config.fontSizeTitle}`}>
        Sub: Joining KIT
      </div>

      <div className={customFontFamily.semibold}>Dear {candidateName.split(" ")[0]},</div>

      <div className="space-y-4 text-justify leading-relaxed">
        <p>
          We are pleased to present you with your <span className={customFontFamily.bold}>Joining Kit.</span> Please find enclosed the following documents for your reference:
        </p>

        <ol className="list-decimal pl-8 space-y-1.5 text-gray-900">
          <li>
            <span className={customFontFamily.bold}>Appointment Letter</span> – Kindly sign and return the duplicate copy to us.
          </li>
          <li>
            <span className={customFontFamily.bold}>Leave Card</span> – To be submitted to the Admin Department.
          </li>
          <li>
            <span className={customFontFamily.bold}>ID Card</span> – Please fill the attached Form and Submit.
          </li>
          <li>
            <span className={customFontFamily.bold}>Income Tax Declaration Form.</span>
          </li>
          <li>
            <span className={customFontFamily.bold}>Independence, Impartiality, Integrity, and Confidentiality Declaration</span> (DYC/FMT-MR/13).
          </li>
          <li>
            <span className={customFontFamily.bold}>Nomination Form -</span> Please fill the attached Form and Submit.
          </li>
        </ol>

        <p>
          You are requested to complete <span className={customFontFamily.bold}>Induction</span> module within <span className={customFontFamily.bold}>15 days</span> of your joining date.
        </p>

        <p>
          <span className={customFontFamily.bold}>Link for the Online Induction module:</span>{" "}
          <a href="https://dycgpl.com/induction" target="_blank" rel="noreferrer" className="text-blue-600 underline">
            https://dycgpl.com/induction
          </a>
        </p>

        <div className="pt-2">
          <div className={`${customFontFamily.bold} mb-2`}>
            For any support or assistance, please feel free to contact us:
          </div>

          <table className={`w-full border-collapse border border-gray-400 ${config.fontSizeXs} my-2`}>
            <thead>
              <tr className={`bg-gray-100 ${customFontFamily.bold} border-b border-gray-400 text-gray-900`}>
                <th className="border border-gray-400 px-3 py-1 align-middle text-left w-1/3">Department</th>
                <th className="border border-gray-400 px-3 py-1 align-middle text-left w-1/3">Email ID</th>
                <th className="border border-gray-400 px-3 py-1 align-middle text-left w-1/3">Contact Number</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-400 px-3 py-1 align-middle">Human Resource (HR)</td>
                <td className="border border-gray-400 px-3 py-1 align-middle">hr@dycgpl.com</td>
                <td className="border border-gray-400 px-3 py-1 align-middle">8652663355</td>
              </tr>
              <tr>
                <td className="border border-gray-400 px-3 py-1 align-middle">Information Technology (IT)</td>
                <td className="border border-gray-400 px-3 py-1 align-middle">itsupport@dycgpl.com</td>
                <td className="border border-gray-400 px-3 py-1 align-middle">9820991541</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Signature gap for physical printing */}
        <div className="pt-8 text-gray-900">
          <div className={customFontFamily.bold}>For DYC Global Pvt. Ltd.</div>
          <div className="h-12"></div>
          <div className={customFontFamily.bold}>HR Department.</div>
        </div>
      </div>
    </div>
  );
};

export default FulltimeJoiningPDF;
